import axiosIns from "./axios"

export const PROFILE = () => {
    return axiosIns.post('/user')
}